import { render, staticRenderFns } from "./UpscaleLabPanel.vue?vue&type=template&id=ac8f91c8&scoped=true"
import script from "./UpscaleLabPanel.vue?vue&type=script&lang=js"
export * from "./UpscaleLabPanel.vue?vue&type=script&lang=js"
import style0 from "./UpscaleLabPanel.vue?vue&type=style&index=0&id=ac8f91c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac8f91c8",
  null
  
)

export default component.exports